import { Injectable } from '@angular/core';
import { baseURL, timeoutTime } from '../../config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/timeoutWith';
import 'rxjs/add/operator/timeout';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  baseUrl = baseURL;
  constructor(private httpClient: HttpClient) {
  }

  getadminpagination(dataTablesParameters): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post(this.baseUrl + 'admin/pagination', dataTablesParameters, { headers })
      .timeoutWith(timeoutTime, Observable.throw(new Error('Timeout error getadminpagination')));
  }

  getbyidadmin(id): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.get(this.baseUrl + `admin/${id}`, { headers })
      .timeoutWith(timeoutTime, Observable.throw(new Error('Timeout error getbyidadmin')));
  }

  changeadminStatus(id, statusdata): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post(this.baseUrl + `admin/change_status/${id}`, statusdata, { headers })
      .timeoutWith(timeoutTime, Observable.throw(new Error('Timeout error changeadminStatus')));
  }

  deleteadmin(id): Observable<any> {
    return this.httpClient.delete(this.baseUrl + `admin/${id}`)
      .timeoutWith(timeoutTime, Observable.throw(new Error('Timeout error deletecity')));
  }

  createadmin(admindata): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post(this.baseUrl + `admin`, admindata, { headers })
      .timeoutWith(timeoutTime, Observable.throw(new Error('Timeout error createadmin')));
  }

  updateadmin(id, updatedata): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.put(this.baseUrl + `admin/${id}`, updatedata, { headers } )
    .timeoutWith(timeoutTime, Observable.throw(new Error('Timeout error updateadmin')));
  }

  getalladminrole(): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.get(this.baseUrl + `adminrole`, { headers } )
    .timeoutWith(timeoutTime, Observable.throw(new Error('Timeout error getalladminrole')));
  }

  archieveadmin(id): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post(this.baseUrl + `admin/archieve/${id}`, { headers })
      .timeoutWith(timeoutTime, Observable.throw(new Error('Timeout error archieveadmin')));
  }

  unarchieveadmin(id): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post(this.baseUrl + `admin/unarchieve/${id}`, { headers })
      .timeoutWith(timeoutTime, Observable.throw(new Error('Timeout error unarchieveadmin')));
  }

  getadminarchivepagination(dataTablesParameters): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post(this.baseUrl + 'admin/archieved/pagination', dataTablesParameters, { headers })
      .timeoutWith(timeoutTime, Observable.throw(new Error('Timeout error getadminarchivepagination')));
  }

  getadmindeletedpagination(dataTablesParameters): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post(this.baseUrl + 'admin/deleted/pagination', dataTablesParameters, { headers })
      .timeoutWith(timeoutTime, Observable.throw(new Error('Timeout error getadmindeletedpagination')));
  }

  
  updateadminlanguage(id): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post(this.baseUrl + `admin/change_lang/${id}`, {}, { } )
    .timeoutWith(timeoutTime, Observable.throw(new Error('Timeout error updateadmin')));
  }
}
